import {SerializedError} from "@reduxjs/toolkit";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

interface IRtkqMutationErrorResponse {
    error: FetchBaseQueryError | SerializedError;
    data?: undefined;
}

interface IRtkqMutationSuccessResponse<T> {
    error?: undefined;
    data: T;
}

export type IRtkqMutationResult<T> = IRtkqMutationErrorResponse | IRtkqMutationSuccessResponse<T>;

export function isRtkqMutationError<T>(response: IRtkqMutationResult<T>): response is IRtkqMutationErrorResponse {
    return "error" in response && response.error !== undefined;
}
import {SerializedError} from "@reduxjs/toolkit";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

interface IRtkqMutationErrorResponse {
    error: FetchBaseQueryError | SerializedError;
    data?: undefined;
}

interface IRtkqMutationSuccessResponse<T> {
    error?: undefined;
    data: T;
}

export type IRtkqMutationResult<T> = IRtkqMutationErrorResponse | IRtkqMutationSuccessResponse<T>;

export function isRtkqMutationError<T>(response: IRtkqMutationResult<T>): response is IRtkqMutationErrorResponse {
    return "error" in response && response.error !== undefined;
}
